/**
 * Global Auth Mutex
 * 
 * Serializes all auth operations to prevent concurrent token acquisition,
 * cache clearing, and redirect processing.
 * 
 * MUST FIX #2: Hard concurrency guarantee, not best-effort UI signal.
 */

class AuthMutex {
  private lock: Promise<void> = Promise.resolve();
  private locked = false;

  /**
   * Acquire the mutex and execute a function
   * All operations are serialized - each waits for the previous to complete
   */
  async acquire<T>(fn: () => Promise<T>): Promise<T> {
    const previousLock = this.lock;
    let releaseLock: () => void;
    
    this.lock = new Promise((resolve) => {
      releaseLock = resolve;
    });
    
    this.locked = true;
    
    try {
      await previousLock; // Wait for previous operation
      return await fn();
    } finally {
      this.locked = false;
      releaseLock!();
    }
  }

  /**
   * Check if mutex is currently locked
   */
  isLocked(): boolean {
    return this.locked;
  }
}

export const authMutex = new AuthMutex();
